import _ from "lodash"
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import withRouter from "components/Common/withRouter"

import {
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap"
import Select from "react-select"
import AsyncSelect from 'react-select/async';

const ConnectForm = ({
  initialValues,
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  submitForm,
  setFieldValue,
  setFieldTouched,
  collection,
  handleSelectChange,
  ...props
}) => {

  let data = _.map(collection, (value, key) => {
    return {    
      id: value.signup_id,
      name: value.applicant,
      address: `${value.address} ${value.city}, ${value.state} ${value.zipcode}`
    }
  });

  data = _.filter(data, function(o) { return o.id != values.signup_id; });

  // Function to filter options based on user input
  const filterOptions = (inputValue) => {
    return data
      .filter((item) =>
        item.name.toLowerCase().includes(inputValue.toLowerCase())
      )
      .slice(0, 50) // Limit results to first 50 matches for performance
      .map((item) => ({
        value: item.id,
        label: `${item.name} - ${item.address} `,
      }));
  };

  // Function to load options asynchronously
  const loadOptions = (inputValue, callback) => {
    if (inputValue.length >= 3) {
      setTimeout(() => {
        callback(filterOptions(inputValue)); // Simulate a network request with a slight delay
      }, 1000); // Simulate 1s delay for fetching options
    } else {
      callback([]); // If less than 3 characters, return empty array
    }
  };

  return (
    <React.Fragment>
      <Form className="form-horizontal" id="connect-form">
        <Row>
          <Input
                type="hidden"
                id="signup_id"
                name="signup_id"
                value={values.signup_id || ""}
                invalid={errors.signup_id ? true : false}
            />
            {touched.signup_id && errors.signup_id ? (
                <FormFeedback
                className="mb-3"
                type="invalid"
                style={{ fontSize: "100%" }}
                >
                {errors.signup_id}
                </FormFeedback>
            ) : null}
          <Col lg="12">           
            <FormGroup className="mb-3">
              <Label htmlFor="co_signer">Search & Add Co-Signer</Label>
              <AsyncSelect
                id="co_signer"
                name="co_signer"
                loadOptions={loadOptions}        // Asynchronously load options
                defaultOptions={[]}              // Initially no options
                cacheOptions                     // Cache options to avoid re-fetching
                placeholder="Type at least 3 characters..."
                isClearable                      // Allow clearing the selection
                noOptionsMessage={() =>
                  "Start typing to search (at least 3 characters)"
                }onChange={selectedOption => {
                    let event = {
                    target: {
                        name: "co_signer",
                        option: selectedOption,
                    },
                    }
                    handleSelectChange(event)
                }}
                invalid={
                    touched.co_signer &&
                    errors.co_signer &&
                    errors.co_signer.value
                    ? true
                    : false
                }
              />
              {touched.co_signer &&
              errors.co_signer &&
              errors.co_signer.value && (
                  <FormFeedback
                      type="invalid"
                      style={{
                      display: "block",
                      fontSize: "100%",
                      }}
                  >
                      {errors.co_signer.value}
                  </FormFeedback>
              )}
              {/* <AsyncSelect
                    id="co_signer"
                    name="co_signer"
                    placeholder="Start typing to search (at least 3 characters)"
                    defaultValue={selectedResidenceLengthValue}
                    value={selectedResidenceLengthValue}
                    onChange={selectedOption => {
                        let event = {
                        target: {
                            name: "residence_length",
                            option: selectedOption,
                        },
                        }
                        handleSelectChange(event)
                    }}
                    isSearchable={true}
                    options={getResidencyLength()}
                    isLoading={false}
                    loadingMessage={() =>
                        "loading homeownership length"
                    }
                    noOptionsMessage={() => "residence_length"}
                    invalid={
                        touched.residence_length &&
                        errors.residence_length &&
                        errors.residence_length.value
                        ? true
                        : false
                    }
                />
                {touched.residence_length &&
                errors.residence_length &&
                errors.residence_length.value && (
                    <FormFeedback
                        type="invalid"
                        style={{
                        display: "block",
                        fontSize: "100%",
                        }}
                    >
                        {errors.residence_length.value}
                    </FormFeedback>
                )} */}
            </FormGroup>
          </Col>
          </Row>
      </Form>
    </React.Fragment>
  )
}

export default ConnectForm 
